import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Impressum() {
  return (
    <div className="pt-32 pb-24" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center gap-2 text-sm mb-8">
          <Link to="/" className="text-[#c8c6c4] hover:text-[#d1af6a]">Home</Link>
          <ChevronRight className="w-4 h-4 text-[#c8c6c4]" />
          <span className="text-[#d1af6a]">Impressum</span>
        </nav>

        <h1 className="font-display text-4xl text-white mb-8">Impressum</h1>

        <div className="prose prose-invert prose-p:text-[#c8c6c4] prose-headings:text-white prose-headings:font-subheading max-w-none space-y-8">
          <section>
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              Serdar Dogan<br />
              Dogan Immobilien<br />
              Billtalstraße 32<br />
              65929 Frankfurt am Main
            </p>
          </section>

          <section>
            <h2>Kontakt</h2>
            <p>
              Telefon: +49 175 6900374<br />
              E-Mail: info@immobilien-dogan.com
            </p>
          </section>

          <section>
            <h2>Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              USt.-ID folgt<br />
              Steuernummer gemäß §139c AO:<br />
              014 812 69442
            </p>
          </section>

          <section>
            <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p>
              Berufsbezeichnung: Immobilienmakler gemäß § 34c GewO<br />
              Zuständige Aufsichtsbehörde: Stadt Frankfurt am Main
            </p>
          </section>

          <section>
            <h2>Erlaubnis nach § 34c GewO</h2>
            <p>
              Die Erlaubnis nach § 34c GewO wurde erteilt durch:<br />
              Stadt Frankfurt am Main
            </p>
          </section>

          <section>
            <h2>Angaben zur Berufshaftpflichtversicherung</h2>
            <p>
              Name und Sitz des Versicherers:<br />
              Allianz Versicherungs-Aktiengesellschaft<br />
              Königinstraße 28<br />
              80802 München<br />
            </p>
          </section>

          <section>
            <h2>Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#d1af6a] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2>Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
          </section>

          <section>
            <h2>Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
              Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2>Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
                <section>
            <h2>Webdesign & Entwicklung</h2>
            <p>Diese Website wurde konzipiert und entwickelt von:</p>
            
              <a href="https://eb-agency.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-2 mt-2 opacity-80 hover:opacity-100 transition-opacity w-fit"
            >
              <img src="/eb-agency-logo.png" alt="EB Agency" className="h-12 w-12" />
                <p> EB Agency </p>
              <span className="text-[#d1af6a] hover:underline text-sm">www.eb-agency.com</span>
            </a>
          </section>
        </div>
      </div>
    </div>
  );
}
